/**
 * Data access control configuration for API endpoints
 * Defines which path parameters or headers need validation against user's role context
 */
export var DataAccessLevel;
(function (DataAccessLevel) {
    DataAccessLevel["TENANT"] = "TENANT";
    DataAccessLevel["DOMAIN"] = "DOMAIN";
    DataAccessLevel["SUBJECT"] = "SUBJECT";
})(DataAccessLevel || (DataAccessLevel = {}));
export var DataAccessSource;
(function (DataAccessSource) {
    DataAccessSource["PATH"] = "path";
    DataAccessSource["HEADER"] = "header";
    DataAccessSource["BODY"] = "body"; // Extract from request body
})(DataAccessSource || (DataAccessSource = {}));
// Predefined common configurations for convenience
export const TENANT_ACCESS = {
    rules: [
        {
            paramName: 'tenantId',
            source: DataAccessSource.PATH,
            level: DataAccessLevel.TENANT
        }
    ],
    allowHierarchicalAccess: true
};
export const DOMAIN_ACCESS = {
    rules: [
        {
            paramName: 'domainId',
            source: DataAccessSource.PATH,
            level: DataAccessLevel.DOMAIN
        }
    ],
    allowHierarchicalAccess: true
};
export const SUBJECT_ACCESS = {
    rules: [
        {
            paramName: 'subjectId',
            source: DataAccessSource.PATH,
            level: DataAccessLevel.SUBJECT
        }
    ],
    allowHierarchicalAccess: true
};
export const TENANT_DOMAIN_ACCESS = {
    rules: [
        {
            paramName: 'tenantId',
            source: DataAccessSource.PATH,
            level: DataAccessLevel.TENANT
        },
        {
            paramName: 'domainId',
            source: DataAccessSource.PATH,
            level: DataAccessLevel.DOMAIN
        }
    ],
    allowHierarchicalAccess: true
};
//# sourceMappingURL=dataAccessControl.js.map